











import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
  components: {
    CreateAccountModalForm: () =>
      import("@/components/CreateAcountModalForm.vue")
  }
})
export default class FiltersAlert extends Vue {
  @Prop(Array) filtersWord!: any;
  @Prop(Object) filterFields!: any;
  @Prop(Function) removeFilterItem!: any;

  openModal() {
    console.log(this.filterFields);
    (this as any).$children
      .find((children: any) => {
        return children.$options._componentTag === "CreateAccountModalForm";
      })
      .showModal();
  }
}
